/**
 * Parses page-builder HTML (top-level divs with data-type and data-* attributes)
 * into an array of blocks. Works in Node (SSR) and browser.
 */
function findEndOfOpeningTag(html: string, start: number): number {
	let i = start
	let inDouble = false
	while (i < html.length) {
		const c = html[i]
		if (!inDouble) {
			if (c === '"') inDouble = true
			else if (c === '>') return i
		} else {
			if (html.slice(i, i + 6) === '&quot;') i += 5
			else if (c === '"') inDouble = false
		}
		i++
	}
	return -1
}

function parseAttributes(attrString: string): Record<string, string> {
	const attrs: Record<string, string> = {}
	let i = 0
	while (i < attrString.length) {
		// skip whitespace
		while (i < attrString.length && /\s/.test(attrString[i])) i++
		if (i >= attrString.length) break
		const nameStart = i
		while (i < attrString.length && /[^\s=]/.test(attrString[i])) i++
		const name = attrString.slice(nameStart, i)
		while (i < attrString.length && attrString[i] !== '=') i++
		if (i >= attrString.length) break
		i++ // skip '='
		while (i < attrString.length && (attrString[i] === ' ' || attrString[i] === '"' || attrString[i] === "'")) {
			if (attrString[i] === '"' || attrString[i] === "'") break
			i++
		}
		const quote = attrString[i]
		if (quote !== '"' && quote !== "'") continue
		i++ // skip opening quote
		const valueStart = i
		while (i < attrString.length) {
			if (attrString.slice(i, i + 6) === '&quot;') {
				i += 6
				continue
			}
			if (attrString[i] === quote) break
			i++
		}
		let value = attrString.slice(valueStart, i)
		value = value.replace(/&quot;/g, '"').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
		attrs[name] = value
		if (i < attrString.length) i++ // skip closing quote
	}
	return attrs
}

export interface IPageBuilderBlock {
	type: string
	id?: string
	attrs: Record<string, string>
}

export function parsePageBuilderHtml(content: string): IPageBuilderBlock[] {
	const blocks: IPageBuilderBlock[] = []
	let pos = 0
	while (pos < content.length) {
		const divStart = content.indexOf('<div', pos)
		if (divStart === -1) break
		const afterTag = divStart + 4 // after '<div'
		const tagEnd = findEndOfOpeningTag(content, afterTag)
		if (tagEnd === -1) break
		const attrString = content.slice(afterTag, tagEnd).trim()
		const attrs = parseAttributes(attrString)
		const dataType = attrs['data-type']
		if (dataType) {
			blocks.push({
				type: dataType,
				id: attrs['data-id'],
				attrs
			})
		}
		pos = tagEnd + 1
		const closeDiv = content.indexOf('</div>', pos)
		if (closeDiv === -1) break
		pos = closeDiv + 6
	}
	return blocks
}
